import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState } from '@/store'
import User from '@/models/User'
import AuthService from '@/services/AuthService'
const authService = new AuthService()

export interface UserState {
  user: User;
  uid: string;
  firebaseToken: string;
  searchKey: string;
}

const state: UserState = {
  user: new User(),
  uid: '',
  firebaseToken: '',
  searchKey: '',
}


const mutations: MutationTree<UserState> = {
  SET_USER(state: any, user: User) {
    if (user.id) {
      state.uid = user.id
    }
    state.user = user
  },
  SET_FIREBASE_TOKEN(state: any, token: string) {
    state.firebaseToken = token
  },
  SET_SEARCH_KEY(state: any, key: string) {
    state.searchKey = key
  },
}

const actions: ActionTree<UserState, any> = {
  async setUser({ commit }) {
    const user = await authService.getUser();
    if (user) {
      commit('SET_USER', user)
    }
  },
  async authStateChanged({ commit, dispatch }, firebaseUser: any) {
    if (firebaseUser) {
      const user = new User()
      user.id = firebaseUser.uid
      if (user) {
        commit('SET_USER', user)
        dispatch('fetchUser', user.id)

        firebaseUser
          .getIdToken()
          .then((token: string) => {
            commit('SET_FIREBASE_TOKEN', token)
          })
          .catch((error: any) => {
            console.error('Error setting Firebase token: ', error)
          })
      }
    }
  },
  async fetchUser({ commit }, uid: string) {
    const user = await authService.fetchUser(uid);
    if (user) {
      commit('SET_USER', user)
    }
  },
  async updateUser({ commit }, item: User) {
    await authService.updateUser(item.id, item.firstName, item.lastName)
      .then(() => {
        commit('SET_USER', item)
      })
  },
  async setFirebaseToken({ commit }, token: string) {
    commit('SET_FIREBASE_TOKEN', token)
  },
  async setSearchKey({ commit }, key: string) {
    commit('SET_SEARCH_KEY', key)
  },
}

const getters: GetterTree<UserState, RootState> = {
  getUser: (state: any) => {
    return state.user
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
